<template>
  <q-form ref="form" class="full-width q-pa-md">
    <input
      style="opacity: 0; position: absolute"
      type="text"
      id="clipboardTextEvent"
    />
    <div class="row items-center">
      <div
        class="col-12 q-mb-sm"
        v-if="
          formData.hasOwnProperty('id') && currentUserData.role == 'superAdmin'
        "
      >
        <q-btn
          color="secondary"
          unelevated
          text-color="accent"
          no-caps
          @click="copy(JSON.stringify(formData))"
        >
          <q-icon size="xs" name="mdi-content-copy" class="q-mr-sm"></q-icon>
          Copy
        </q-btn>
      </div>
      <div class="col-12 q-px-sm">
        <vue-json-pretty :data="formData" @click="handleClick">
        </vue-json-pretty>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import VueJsonPretty from "vue-json-pretty";

  export default {
    components: { VueJsonPretty },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteData: "settings/siteData",
      }),
    },
    props: {
      data: {
        type: Object,
        default: null,
      },
    },
    watch: {
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {},
      keyRegenLoading: false,
    }),
    beforeCreate() {
      this.$store.dispatch("applications/loadAll");
    },
    mounted() {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {};
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$refs.form.validate().then((result) => {
            if (result) {
              if (this.currentUserData.role != "superAdmin") {
                this.formData.applications_id = this.siteData.id;
              }
              this.$store
                .dispatch("devices/new", this.formData)
                .then((result) => {
                  this.$emit("loadingStateChanged", false);
                  if (result.Result == "Success") {
                    this.$emit("close", true);
                    this.formData = {};
                    this.$q.notify({
                      position: "top-right",
                      type: "info",
                      message: result.Response.MessageK,
                      timeout: 0,
                    });
                    this.$q.notify({
                      position: "top-right",
                      type: "positive",
                      message: result.Response.Message,
                    });
                  } else {
                    this.$q.notify({
                      position: "top-right",
                      type: "negative",
                      message: result.Response.Message,
                    });
                  }
                });
            } else {
              this.$emit("loadingStateChanged", false);
            }
          });
        }, 200);
      },
      save() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$store.dispatch("devices/save", this.formData).then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message,
              });
            }
          });
        });
      },
      copy(data) {
        var copyText = document.querySelector("#clipboardTextEvent");
        copyText.value = data;
        copyText.select();
        setTimeout(() => {
          document.execCommand("copy");
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: "Copied to clipboard",
          });
        }, 100);
      },
    },
  };
</script>
